import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/dagk4nbep053ijub2bq0";

export default function Contact() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">(
    "idle"
  );
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // 蜜罐检测
    const honeypot = String(data.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }

    setStatus("loading");
    setFormError("");
    try {
      const payload = new URLSearchParams();
      data.forEach((value, key) => {
        if (key === "website_alt") return;
        if (value instanceof File) return;
        payload.append(key, String(value));
      });

      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null =
        null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText;

      if (
        !res.ok ||
        !parsed ||
        parsed.code !== "OK" ||
        /spam|form data is spam/i.test(serverMsg || "")
      ) {
        setStatus("error");
        setFormError(serverMsg && !/spam/i.test(serverMsg) ? serverMsg : "提交失败，请稍后再试。");
        return;
      }

      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="contact" className="bg-background-100 py-14 md:py-20">
      <div className="container-page">
        <div className="overflow-hidden rounded-3xl bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            {/* 左侧说明 */}
            <div className="flex flex-col justify-between bg-gradient-to-br from-primary-500 to-primary-700 p-8 text-background-50 md:p-10 lg:col-span-2">
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3.5 py-1.5 text-sm font-bold">
                  <i className="ri-send-plane-line"></i>
                  来找我们
                </span>
                <h2 className="heading-font mt-5 text-2xl leading-snug md:text-3xl">
                  有好瓜？好梗？
                  <br />
                  快来投稿
                </h2>
                <p className="mt-4 text-sm leading-7 text-background-50/85">
                  无论是让你笑喷的热评、自制的表情包，还是惊人的网友反应，发给我们，让更多人一起乐一乐。
                </p>
              </div>
              <ul className="mt-8 space-y-3 text-sm">
                {[
                  { icon: "ri-mail-line", text: "tougao@mingxingchigua.com" },
                  { icon: "ri-time-line", text: "投稿审核：1-2 个工作日" },
                  { icon: "ri-shield-check-line", text: "尊重原创，注明出处，杜绝造谣" },
                ].map((it) => (
                  <li key={it.icon} className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15">
                      <i className={it.icon}></i>
                    </span>
                    <span>{it.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* 右侧表单 */}
            <div className="p-6 md:p-10 lg:col-span-3">
              {status === "success" ? (
                <div className="flex h-full flex-col items-center justify-center py-14 text-center">
                  <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-check-line text-3xl"></i>
                  </span>
                  <h3 className="heading-font mt-5 text-xl text-foreground-900">
                    投稿收到啦！
                  </h3>
                  <p className="mt-2 max-w-sm text-sm text-foreground-600">
                    感谢你的分享，审核通过后我们就会把你的热评/表情包/段子收录进专区。
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-readdy-form="投稿联系表单">
                  <h3 className="text-lg font-bold text-foreground-900">
                    投递你的快乐
                  </h3>
                  <p className="mt-1 text-sm text-foreground-500">
                    请尽量填写准确信息，便于我们联系你
                  </p>

                  <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <label className="block">
                      <span className="mb-1.5 block text-sm font-medium text-foreground-700">
                        你的昵称
                      </span>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder="如：爱吃瓜的小王"
                        className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-primary-400"
                      />
                    </label>
                    <label className="block">
                      <span className="mb-1.5 block text-sm font-medium text-foreground-700">
                        联系邮箱
                      </span>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="you@example.com"
                        className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-primary-400"
                      />
                    </label>
                  </div>

                  <label className="mt-4 block">
                    <span className="mb-1.5 block text-sm font-medium text-foreground-700">
                      投稿类型
                    </span>
                    <select
                      name="type"
                      className="w-full cursor-pointer rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-primary-400"
                    >
                      <option>爆笑热评</option>
                      <option>神梗段子</option>
                      <option>自制表情包</option>
                      <option>网友反应素材</option>
                      <option>其他</option>
                    </select>
                  </label>

                  <label className="mt-4 block">
                    <span className="mb-1.5 block text-sm font-medium text-foreground-700">
                      投稿内容 / 链接
                    </span>
                    <textarea
                      name="content"
                      required
                      rows={4}
                      maxLength={500}
                      placeholder="把想投的内容、原评论截图链接或说明写在这里，不超过 500 字"
                      className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-primary-400"
                    ></textarea>
                  </label>

                  {/* 蜜罐隐藏字段 */}
                  <label className="form-field-hint">
                    网站留言
                    <input
                      type="text"
                      name="website_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                  </label>

                  {status === "error" && formError && (
                    <p className="mt-3 rounded-md bg-primary-100 px-4 py-2.5 text-sm text-primary-800">
                      {formError}
                    </p>
                  )}

                  <button
                    type="submit"
                    disabled={status === "loading"}
                    className="btn-ripple mt-6 w-full rounded-full bg-primary-500 py-3 text-background-50 hover:bg-primary-600 disabled:opacity-60"
                  >
                    {status === "loading" ? "提交中…" : "提交投稿"}
                    <i className="ri-send-plane-line"></i>
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}